import HomePage from "../pages/HomePage";
import NotFoundPage from "../pages/NotFoundPage";
import AppLayout from "../components/Layout";
import paths from "../api/paths";
// import StoryPage from "../pages/StoryPage";

export const routes = [
  {
    element: <AppLayout />,
    children: [
      {
        path: paths.homePage,
        element: <HomePage />,
      },
      // {
      //   path: paths.storyPage,
      //   element: <StoryPage />,
      // },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];
